import { Route, Routes } from '@angular/router';
import * as _ from 'lodash';
import { environment } from 'src/environments/environment';
import { HealthcheckComponent } from './components/healthcheck/healthcheck.component';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { AuthGuard } from './guards/auth.guard';
import { FeatureGuard } from './guards/feature.guard';

export const appRoutes: Routes = [
  { path: 'healthcheck', component: HealthcheckComponent },
  {
    path: 'cm',
    canActivate: [AuthGuard, FeatureGuard],
    data: { feature: environment.applicationApplinkFeature }, 
    loadChildren: () =>
      import('./modules/templates/template.module').then((m) => m.TemplateModule),
  },
  {
    path: 'looker',
    canActivate: [AuthGuard, FeatureGuard],
    data: { feature: environment.applicationApplinkFeature },
    loadChildren: () => import('./modules/looker/looker.module').then((m) => m.LookerModule),
  },
  { path: '', component: LandingPageComponent, 
    canActivate: [AuthGuard, FeatureGuard], 
    data: { feature: environment.applicationApplinkFeature }
 },
  { path: '**', component: PageNotFoundComponent },
];

export function componentFromRoute(route: string): Route {
  const myRoute = _.find(appRoutes, { path: route });
  return myRoute;
}
